const Actions = {
    setPage({commit}, data) {
        if ('location' in data) commit('setPageCurrentLocation', data.location)
        if ('title' in data) commit('setPageTitle', data.title)
        if ('breadcrumb' in data) commit('setPageBreadCrumb', data.breadcrumb)
    },
    makeCookies({commit}) {
        localStorage.setItem('accept-cookies', true);
        commit('setCookies', true)
    },
    generalConfig({commit},data) {
        commit('setMemberStatus',data.online)
        commit('setServerInfo',data.server)
        commit('setTop3PlayerRank', data.player)
        commit('setTop3GuildRank', data.guild)
        commit('setTop3PkerRank', data.pker)
    },
    setDashboardData({commit}, data) {
        if ('character' in data) commit('changeDashboardCharacter', data.character)
        if ('page' in data) commit('changeDashboardPage', data.page)
        if ('direction' in data) commit('changeDashboardCharacterDirection', data.direction)
    }
}

export default Actions;